export default __webpack_public_path__ + "static/media/Omniwheel@3x.6e0a4b01.png";